<div class="cookie-consent" [ngClass]="{'slide-up':!isAccepted}">
  <div class="cookie-consent-text">
    <p>{{'cookie_consent_description' | translate}}</p>
  </div>

  <div class="cookie-consent-actions flex-row">
    <a (click)="onAccepted()" class="btn btn-save">{{'accept' | translate}}</a>
    <a (click)="openTermCondition($event)" class="btn">{{'more_info' | translate}}</a>
  </div>

  @if (termConditions) {
    <box-modal (closeSelf)="showBoxModal($event)" (click)="showBoxModal($event)" [isLoading]="isLoaded">
      <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block; max-width: 100%;  height: 100vh;" [autoresize]="false"
        [original-size]="true" [fit-to-page]="true" (after-load-complete)="afterLoadComplete($event)" (on-progress)="onProgress($event)"
      (error)="onError($event)"></pdf-viewer>
      @if (!isLoaded) {
        <div class="site-loader-wrapper">
          <div class="loader"></div>
        </div>
      }
    </box-modal>
  }

</div>